<div class="search-client-input">
  <input
    class="form-control lna"
    #searchInput
    [(ngModel)]="value"
    [ngClass]="{ invalid: invalid }"
    (input)="onChange($event)"
    (focus)="onFocus()"
    type="text"
    placeholder="Meklēt klientu" />
  <button class="clear-search" (click)="clearSearch()" type="button">
    <img src="assets/images/close-icon.svg" alt="clear" />
  </button>
  @if ((clients.length > 0 || searchResults.length > 0) && isActive) {
    <div class="select-client-dropdown" #dropdown>
      @for (client of clients; track client.id) {
        <button class="client-item" (click)="selectClient(client)">
          {{ client.fullName }}
          ({{ client.officialDocumentId ?? '-' }})
        </button>
      }
      @for (result of searchResults; track result.id) {
        <button class="client-item" (click)="selectLegalEntity(result)">
          {{ result.displayName }}
          ({{ result.displayId }})
        </button>
      }
    </div>
  }
  @if (isLoading) {
    <div class="spinner-wrapper">
      <div class="spinner"></div>
    </div>
  }
</div>
